export default __webpack_public_path__ + "static/charlotte@2x-3863179dd6dbcb8a628b03c5f5e2b8aa.png";